import { useQuery } from "@tanstack/react-query"

interface SlotItem {
  duration_id: string
  time_from: string
  time_to: string
  is_morning: boolean
  applicable_days: number[]
  current_appointments: string
  remaining_slots: number
}

interface SlotsResponse {
  status: string
  statusCode: number
  message: string
  data: SlotItem[]
}

async function fetchTimeSlots(
  branchId: string,
  serviceId: string,
  appointmentDate: string
): Promise<SlotItem[]> {
  if (!branchId || !serviceId || !appointmentDate) return []

  const params = new URLSearchParams({
    branch_id: branchId,
    branch_service_id: serviceId,
    appointment_date: appointmentDate,
    slot: "paid",
  })
  const apiUrl = import.meta.env.VITE_API_URL || import.meta.env.NEXT_PUBLIC_API_URL || ''
  const url = `${apiUrl}/v1/appointments/availableTimeSlotsByDateWithPercentage?${params.toString()}`
  const res = await fetch(url, { cache: "no-store" })

  if (!res.ok) {
    return []
  }

  const json = (await res.json()) as SlotsResponse
  return Array.isArray(json?.data) ? json.data : []
}

/** Interval (ms) to check backend for slot updates without showing loading UI */
const SLOTS_REFETCH_INTERVAL_MS = 45_000

export function useTimeSlots(branchId: string, serviceId: string, appointmentDate: string) {
  return useQuery({
    queryKey: ["timeSlots", branchId, serviceId, appointmentDate],
    queryFn: () => fetchTimeSlots(branchId, serviceId, appointmentDate),
    enabled: !!(branchId && serviceId && appointmentDate),
    refetchInterval: SLOTS_REFETCH_INTERVAL_MS,
    refetchIntervalInBackground: false,
  })
}

